import { defineMessages } from 'react-intl';

export default defineMessages({
  boardIsEmpty: {
    id: 'cboard.components.Board.boardIsEmpty',
    defaultMessage: 'This board is empty'
  }
});
